<template lang="html">
  <div v-if="isLoading"></div>
  <div v-else>

  <!-- <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <meta property="og:title" content="NerzExpress" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://ex.nerz.jp" />
  <meta property="og:image" content="https://ex.nerz.jp/img/ogp-image.png" />
  <meta property="og:site_name" content="NerzExpress" />
  <meta property="og:description" content="NerzExpress is a service that connects you to fellow otaku in Japan. You will be able to engage with these otaku in various ways such as purchasing owned items directly from them or negotiating terms with them to purchase items for you when they attend various events!" />
  <meta name="twitter:card" content="summary_large_image"> -->
  <link rel="icon" href="https://ex.nerz.jp/img/favicon.png">

  <div class="fixed-btn">
    <router-link to="/login">
      <btn size="normal" type="primary" label="Sign up or Login"></btn>
    </router-link>
  </div>

  <div class="content">
    <div class="header-wrapper">
      <div class="header bg-yayoi">
        <div class="logo">
          <img src="../../assets/img/logo.svg">
          <p class="logo-subtitle w4 color-yukiho">Unlimited Proxy Works</p>
          <router-link tag="div" to="/login" class="m-t-20 pc">
            <btn size="normal" type="white" label="Login" style="border: none;"></btn>
          </router-link>
        </div>
        <div class="nazuna-top">
          <img src="../../assets/img/nazuna-top.png">
        </div>
        <div class="arrow arrow-down arrow-1" style="bottom: -22vh;"></div>
        <div class="arrow arrow-down arrow-2" style="bottom: -25vh;"></div>
        <div class="arrow arrow-down arrow-3" style="bottom: -28vh;"></div>
      </div>
    </div>

    <router-link tag="div" to="/login" id="join-button" class="join-button bg-yayoi">
      <btn size="normal" type="primary" label="Login"></btn>
    </router-link>

    <div class="about-nerzex section">
      <div class="ex-title anim-left" data-delighter>
        <div class="ex-title-nazuna ex-title-1"></div>
        <div class="ex-title-cover"></div>
        <div class="ex-title-line"></div>
        <p class="color-yukiho w6">サービスが生まれるまで</p>
      </div>

      <fade-in default="isSpawn">
        <p class="history-message">
          世界のどこにいても最高のオタクライフを
        </p>
      </fade-in>
      <fade-in default="isSpawn2">
        <div class="history">
          <p>英語圏向けにやっていた日本でのアニメ関連イベントやイラストレーター様、コスプレイヤー様を紹介するメディアのファンからニーズを聞き出し生み出されたサービスです。</p>
          <p>どこにいても同じ様に好きなコンテンツに触れていられる様、我々は世界に貢献と思い創業しました。</p>
          <p>Unitiying Borderless Worldという社名にもその意味を込めています。</p>
        </div>
      </fade-in>

      <div class="solution">
        <fade-in>
          <div class="solution-title">
            <p>NerzExpress とは</p>
          </div>
        </fade-in>
        <div class="service-flow">
          <!-- <p class="service-flow-title"> Service Flow</p> -->
          <fade-in>
            <img src="../../assets/img/howto1.png">
          </fade-in>
          <fade-in>
            <img src="../../assets/img/howto2.png">
          </fade-in>
          <fade-in>
            <img src="../../assets/img/howto3.png">
          </fade-in>
        </div>
      </div>
    </div>

    <div class="easy-of-use section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-nazuna ex-title-nazuna-reverse ex-title-2"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">ユーザーの声</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="happy-wrapper">
          <div class="happy-content">
            <div class="happy-photo" style="background-image: url('https://pbs.twimg.com/media/ELI7HR2UEAAOysy?format=jpg&name=medium');"></div>
            <p class="happy-text">
              <a class="user-name" href="https://twitter.com/0GeeMI/status/1203089080205996032">@0GeeMI</a>
              My order from http://ex.nerz.jp came in today! Great website if you're looking to get limited items from Japan! Thanks @nerz_jp
            </p>
          </div>
          <div class="happy-content">
            <div class="happy-photo" style="background-image: url('https://pbs.twimg.com/media/ENqrOvpU4AA6rpX?format=jpg&name=medium');"></div>
            <p class="happy-text">
              <a class="user-name" href="https://twitter.com/dollmiraceti/status/1214471329975394306">@dollmiraceti</a>
              Got my special New Years Precure Pretty Store bag from @nerz_jp
              I'm so happy aaaaa!! The blanket is so soft, and my wife is so beautiful. Please use their service, I highly recommend it if you want limited goods.
            </p>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="provide-fb section">
      <fade-in>
        <div class="ex-title anim-left" data-delighter>
          <div class="ex-title-nazuna ex-title-3"></div>
          <div class="ex-title-cover"></div>
          <div class="ex-title-line"></div>
          <p class="color-yukiho w6">リクエスト・出品一覧</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="products">
          <div class="product-wrapper" v-for="(val, key) in requests">
            <router-link :to="`/request/${val.id}`">
              <div class="request-img" :style="`background-image:url(${val.img1})`">
                <p class="request-price">{{val.price}} JPY</p>
              </div>
              <div class="request-name-wrapper">
                <p class="request-name">{{val.name}}</p>
              </div>
            </router-link>
          </div>
          <div class="product-wrapper" v-for="(val, key) in items">
            <router-link :to="`/item/${val.id}`">
              <div class="request-img" :style="`background-image:url(${val.img1})`">
                <p class="request-price">{{val.price}} JPY</p>
              </div>
              <div class="request-name-wrapper">
                <p class="request-name">{{val.name}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-nazuna ex-title-nazuna-reverse ex-title-4"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">よくある質問</p>
        </div>
      </fade-in>

      <fade-in>
        <nav class="accordion arrows">
          <input type="radio" name="accordion" id="cb1" />
          <section class="box">
            <label class="box-title" for="cb1">対応している国は？</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../assets/img/def.png" alt="">
              <p>決済に対応している国は、</p>
              <p>アイルランド、イギリス、イタリア、インド、エンストニア、オランダ、オーストラリア、オーストリア、カナダ、ギリシャ、シンガポール、スイス、スウェーデン、スペイン、スロバキア、スロベニア、デンマーク、ドイツ、ニュージーランド、ノルウェー、フィンランド、フランス、ベルギー、ポルトガル、ポーランド、マレーシア、メキシコ、ラトビア、リトアニア、ルクセンブルク、日本、米国、香港</p>
              <p>です！特に現在はStripeを決済に使っているけどG Cashなども対応していきたいと思っています。</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb2" />
          <section class="box">
            <label class="box-title" for="cb2">利用料はかかりますか？</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../assets/img/def.png" alt="">
              <p>プラットフォームの利用料は無料です！</p>
              <p>販売手数料などは一切かかりませんが、決済サービスの決済手数料と振込手数料がかかります。</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb3" />
          <section class="box">
            <label class="box-title" for="cb3">英語が出来なくても使えますか？</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../assets/img/def.png" alt="">
              <p>サービス内は日本語で使えるので問題ないけど、取引は英語の可能性もあるので、翻訳などを使ってね！</p>
              <p>取引も定型文を用意して各言語に翻訳して使える様に準備を進めているので少々お待ちください！</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb4" />
          <section class="box">
            <label class="box-title" for="cb4">リクエストに応えるメリットは？</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../assets/img/def.png" alt="">
              <p>リクエストに応えてあげると、自分のアカウントの評価が上がっていく様になっているよ！</p>
              <p>評価の高いユーザーは信用されやすいのと、今後は高評価のユーザーへの優待も考えているよ！</p>
              <p>また、現状はリクエストに応えると別途お礼金（チップ）も貰えるよ！</p>
            </div>
          </section>

          <input type="radio" name="accordion" id="acc-close" />
        </nav>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title anim-left" data-delighter>
          <div class="ex-title-5"></div>
          <div class="ex-title-cover"></div>
          <div class="ex-title-line"></div>
          <p class="color-yukiho w6">お知らせ</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="news">
          <div class="news-content">
            <p class="news-date">
              2019.11.3
            </p>
            <p class="news-text"></p>
            <a class="news-title" href="/"><p>サービスをリリースしました</p></a>
          </div>
          <div class="news-content">
            <p class="news-date">
              2019.12.24
            </p>
            <p class="news-text"></p>
            <a class="news-title" href="https://ubw.co.jp"><p>株式会社UBWを設立。運営を個人から法人にしました。</p></a>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-6"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">求人</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="banner-text">
          <p>現在、株式会社UBWでは一緒により良いオタクライフを作っていく仲間を募集しています。</p>
          <p>副業、業務委託、バイト、インターンなんでも相談可能ですのでお気軽にお問い合わせ下さい。</p>
        </div>
      </fade-in>
      <div class="banner-flex">
        <fade-in>
          <div class="banner">
            <a href="mailto:info@nerz.jp">
              <img src="../../assets/img/engineer-banner.png">
            </a>
          </div>
        </fade-in>
        <fade-in>
        <div class="banner">
          <a href="mailto:info@nerz.jp">
            <img src="../../assets/img/business-banner.png">
          </a>
        </div>
        </fade-in>
      </div>
    </div>


    <div class="footer color-yukiho">
      <p>運営会社：<a href="https://ubw.co.jp">株式会社UBW</a></p>
      <p><a href="/terms-of-service">利用規約</a></p>
      <p><a href="/privacy-policy">プライパシーポリシー</a></p>
      <p>©2018 Nerz Powerd by https://nerz.jp</p>
    </div>
    <!-- content end -->
  </div>

  <!-- <div class="modal">
    <div class="form-area">
      <p class="modal-title color-yukiho">Please input your data</p>
      <div class="form-item">
        <input type="text" class="email-data" placeholder="email">
      </div>
      <div class="form-item">
        <input type="text" class="name-data" placeholder="Nickname">
      </div>
      <div class="form-item">
        <input type="text" class="friendcode-data" placeholder="Friend code (if you have)">
      </div>
      <div class="button bg-yayoi color-yukiho" onclick="sendData()" >Register</div>
      <p class="error-text"></p>
    </div>
    <div class="modal-thanks" onclick="closeModal()">
      <p class="thanks-text">Thanks for the pre-register!! Go check the mail I've just sent you and gain the discount coupon!!</p>
      <div class="thanks-img">
        <img src="../../assets/img/nazuna-wink.png">
      </div>
    </div>
    <div class="loading">
      <div>
        <img src="../../assets/img/puff.svg" />
      </div>
    </div>
    <div class="modal-back" onclick="closeModal()"></div>
  </div> -->
</div>

</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=UA-128988234-1"></script>
<script
  src="https://code.jquery.com/jquery-3.3.1.min.js"
  integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8="
  crossorigin="anonymous">
</script>
<script src="./js/delighters.min.js"></script>
<script>

 window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-128988234-1');
</script>

<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>

<script>
import axios from 'axios'
import Btn from '../../components/Button.vue'
import FadeIn from '../../components/FadeIn.vue'

export default {
  name: 'NerzExpress',

  components: {
    Btn,
    FadeIn,
  },

  data() {
    return {
      requests: [],
      items: [],
      isLoading: true,
      isSpawn: '',
      isSpawn2: '',
    };
  },

  mounted() {
    let langGet = navigator.language
    if(langGet !== "ja") {
      this.$router.push("/en")
    }
    axios.get('public/get_requests').then((data)=> {
      this.requests = data.data.model.reverse()
    }).catch((err) => {
      console.log(err)
    })
    axios.get('public/get_items').then((data)=> {
      this.items = data.data.model.reverse()
    }).catch((err) => {
      console.log(err)
    })

    if(window.outerHeight > 995) {
      this.isSpawn = true
    }
    if(window.outerHeight > 1385) {
      this.isSpawn2 = true
    }

    this.isLoading = false
  },
}
</script>

<style src="./css/reset.css"></style>
<style src="./css/layout.css"></style>
<style src="./css/common.css"></style>
<style src="./css/about.css"></style>
<style src="./css/aboutnazuna.css"></style>
<style src="./css/anime.css"></style>
<style src="./css/card.css"></style>
<style src="./css/feedback.css"></style>
<style src="./css/header.css"></style>
<style src="./css/modal.css"></style>
<style src="./css/point.css"></style>
<style src="./css/title.css"></style>
<style src="./css/product.css"></style>
<style src="./css/question.css"></style>
<style src="./css/news.css"></style>
<style src="./css/banner.css"></style>
<style src="./css/happy.css"></style>
